export const focusRing = {
    outline: "none",
    "&:focus-visible": {
        outline: "var(--j-focus-w) solid var(--j-accent)",
        outlineOffset: "var(--j-focus-offset)"
    }
};
export const pressable = {
    transition: "transform 100ms ease-out, background-color 150ms, opacity 150ms",
    "&:active:not(:disabled)": {
        transform: "scale(.97)"
    },
    "@media (prefers-reduced-motion: reduce)": {
        transition: "none",
        "&:active:not(:disabled)": {
            transform: "none"
        }
    }
};
export const reducedMotion = "@media (prefers-reduced-motion: reduce)";
export const thinScrollbar = {
    "&::-webkit-scrollbar": {
        width: "var(--j-sp-1-5)",
        height: "var(--j-sp-1-5)"
    },
    "&::-webkit-scrollbar-thumb": {
        border: "1px solid transparent",
        borderRadius: "var(--j-r-sm)",
        backgroundClip: "padding-box",
        backgroundColor: "var(--j-line)"
    },
    "&:hover::-webkit-scrollbar-thumb": {
        backgroundColor: "var(--j-line-strong)"
    }
};
